<template>
  <v-container fluid :style="[esDesktop ? cssProps : '']" class="ma-0 pa-0">
    <v-row justify="center" class="ma-0 pa-0 py-md-5 py-lg-5 py-xl-5 mb-6">
      <v-col class="ma-0 pa-0" xs="12" sm="12" md="6" lg="6" xl="6">
        <v-card
          v-if="esDesktop"
          class="pt-3 pt-xs-3 pt-sm-4 pt-md-1 pt-lg-1 pt-xl-1 pb-5"
          elevation="6"
        >
          <router-view></router-view>
        </v-card>
        <router-view v-else class="mt-3"></router-view>
      </v-col>
    </v-row>
    <Error />
    <Exito />
  </v-container>
</template>

<script>
import Error from '@/components/compartidos/Error.vue'
import Exito from '@/components/compartidos/Exito.vue'

export default {
  name: 'Layout',
  components: { Error, Exito },
  data: () => ({
    cssProps: {
      backgroundImage: `url(${require('@/assets/images/fondo_desktop.png')})`,
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover',
      height: '100%',
    },
  }),
  computed: {
    esDesktop() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return false
        case 'sm':
          return false
        case 'md':
          return true
        case 'lg':
          return true
        case 'xl':
          return true
        default:
          return true
      }
    },
  },
}
</script>

<style scoped>
.container-desktop {
  background-color: #77b82a;
  height: 100%;
}
</style>
